import { Language } from './base';

const pdash = () => import('../translations/pdash/es-ES.json');
const webActivities = () => import('../translations/web-activities/es-ES.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/es-ES.json');

export default new Language({
    code: 'es-US',
    locale: 'es',
    localName: 'Español',
    englishName: 'Spanish',
    territory: 'US',
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
